export const shadows = {
  shadow01: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
};
